
export enum TrackingEvents {
  // Dashboard Events
  VIEW_JUZ_STUDENTS = 'view-juz-students',

  // Reports Events
  EXPORT_WEEK_ACHIEVEMENT_EXCEL = 'export-week-achievement-excel',
  FILTER_WEEK_ACHIEVEMENT_BY_SESSION = 'filter-week-achievement-by-session',
  EXPORT_TODAY_ACHIEVEMENT_EXCEL = 'export-today-achievement-excel',
  FILTER_TODAY_ACHIEVEMENT_BY_SESSION = 'filter-today-achievement-by-session',
  EXPORT_RANGE_ACHIEVEMENT_EXCEL = 'export-range-achievement-excel',
  FILTER_RANGE_ACHIEVEMENT_BY_SESSION = 'filter-range-achievement-by-session',
  VIEW_TODAY_ACHIEVEMENT_REPORT = 'view-today-achievement-report',
  VIEW_WEEK_ACHIEVEMENT_REPORT = 'view-week-achievement-report',
  VIEW_RANGE_ACHIEVEMENT_REPORT = 'view-range-achievement-report',

  // Session Events
  VIEW_STUDENT_DETAILS = 'view-student-details',
  EXPORT_SESSION_REPORT = 'export-session-report',
  MOVE_SELECTED_STUDENTS = 'move-selected-students',
  EXPORT_SELECTED_SESSIONS_REPORT = 'export-selected-sessions-report',

  // Attendance/Presence Events
  EXPORT_ATTENDANCE_EXCEL = 'export-attendance-excel',
  SELECT_STUDENT_ATTENDANCE = 'select-student-attendance',
  MARK_ATTENDANCE_PRESENT = 'mark-attendance-present',
  MARK_ATTENDANCE_ABSENT = 'mark-attendance-absent',
  MARK_ATTENDANCE_EXCUSED = 'mark-attendance-excused',
  MARK_ATTENDANCE_LATE = 'mark-attendance-late',
  AUTO_MARK_ATTENDANCE = 'auto-mark-attendance',

  // Absence Events
  CONFIRM_SINGLE_ABSENCE = 'confirm-single-absence',
  EXPORT_ABSENCE_STATISTICS = 'export-absence-statistics',
  CONFIRM_MULTIPLE_ABSENCES = 'confirm-multiple-absences',

  // Student Management Events
  CREATE_NEW_STUDENT = 'create-new-student',
  EXPORT_STUDENTS_EXCEL = 'export-students-excel',
  EXPORT_STUDENTS_PDF = 'export-students-pdf',
  EXPORT_STUDENTS_QR = 'export-students-qr',
  EXPORT_STUDENT_REPORT = 'export-student-report',
  VIEW_STUDENT_PERSONAL_INFO = 'view-student-personal-info',
  VIEW_STUDENT_EDUCATIONAL_INFO = 'view-student-educational-info',
  VIEW_STUDENT_PLAN = 'view-student-plan',
  UPDATE_STUDENTS_PLAN = 'update-students-plan',

  // Evaluation Events
  CONFIRM_STUDENT_EVALUATION = 'confirm-student-evaluation',
  CANCEL_STUDENT_EVALUATION_CONFIRMATION = 'cancel-student-evaluation-confirmation',
  TOGGLE_STUDENT_HEARING_STATUS = 'toggle-student-hearing-status',
  CANCEL_STUDENT_EVALUATION = 'cancel-student-evaluation',
  MARK_STUDENT_PRESENT = 'mark-student-present',
  MARK_STUDENT_ABSENT = 'mark-student-absent',
  MARK_STUDENT_EXCUSED = 'mark-student-excused',
  MARK_STUDENT_LATE = 'mark-student-late',
  SELECT_MEMORIZATION_EVALUATION = 'select-memorization-evaluation',
  SELECT_REVIEW_EVALUATION = 'select-review-evaluation',
  SELECT_ENSURE_EVALUATION = 'select-ensure-evaluation',
  SELECT_EVALUATION_TAB = 'select-evaluation-tab',
  TOGGLE_EVALUATION_EDIT_MODE = 'toggle-evaluation-edit-mode',
  MARK_NO_HEARING_RECITATION = 'mark-no-hearing-recitation',

  // Quran/Surah Selection Events
  SELECT_SURAH_START_POINT = 'select-surah-start-point',
  SELECT_SURAH_END_POINT = 'select-surah-end-point',
  SELECT_VERSE_NUMBER = 'select-verse-number',
  CLOSE_VERSE_SELECTION_MODAL = 'close-verse-selection-modal',
} 